export default function reloadPage() {
  window.location.reload();
}
